import {
	amenagementBalcon,
	amenagementGalerie,
	amenagementperron,
	amenagementporche
} from '@images/icons'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import Breakpoints from '@utils/breakpoints'
import { Colors } from '@utils/css-variables'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import { makeClasses } from '@utils/styles'

type Classes = {
	button: string
	outlinedButton: string
	fieldsContainer: string
	buttonContainer: string
	fileHelperSection: string
	fileContainer: string
	inputContainer: string
	checkbox2: string
	checkbox2Label: string
	checkbox2Container: string
	checkboxWrapper: string
	adresseBlock: string
	h5: string
	h6: string
	greyBackgroundBlock: string
	detailscontainer: string
	subContent: string
	reducedMarginBottom: string
	image: string
	errorCheck: string
}

export const classes: Classes = makeClasses({
	button: {
		display: 'inline-block',
		padding: '10px 20px',
		fontSize: '13px',
		fontWeight: '500',
		color: Colors.white,
		lineHeight: '1em',
		borderRadius: '23px',
		transition: 'all 0.35s ease',
		MsTransition: 'all 0.35s ease',
		background: Colors.secondary,
		border: 'none',
		cursor: 'pointer',
		'&:hover': {
			background: Colors.darkBlue2,
			borderColor: Colors.darkBlue2,
			color: Colors.white
		}
	},
	outlinedButton: {
		background: 'none',
		border: `1px solid ${Colors.secondary} !important`,
		color: Colors.secondary
	},
	fieldsContainer: {
		[Breakpoints.minWidth('md')]: {
			display: 'grid',
			columnGap: '20px',
			gridTemplateColumns: '1fr 1fr',
			alignItems: 'end'
		}
	},
	buttonContainer: {
		display: 'flex',
		width: 'fit-content',
		columnGap: '4px'
	},
	fileHelperSection: {
		background: Colors.darkWhite,
		padding: '30px',
		marginBottom: '15px'
	},
	fileContainer: {
		'.blue-bullets-list': {
			ul: {
				padding: '0px 15px 0px 20px'
			}
		}
	},
	inputContainer: {
		marginBottom: '20px'
	},

	checkbox2: {
		width: 'fit-content',
		position: 'absolute',
		verticalAlign: 'baseline',
		clip: 'rect(1px, 1px, 1px, 1px)'
	},
	checkbox2Label: {
		fontSize: '16px',
		padding: '0',
		color: Colors.lightBlack,
		position: 'relative',
		paddingLeft: '27px',
		fontWeight: 'normal',
		cursor: 'pointer',
		lineHeight: '17px',
		':before': {
			content: "''",
			position: 'absolute',
			top: '0',
			left: '0',
			width: '16px',
			height: '16px',
			border: `1px solid ${Colors.lightGrey3}`,
			background: Colors.white,
			outline: 'none !important'
		},
		':after': {
			content: "''",
			position: 'absolute',
			top: '4px',
			left: '4px',
			width: '10px',
			height: '10px',
			background: Colors.secondary,
			outline: 'none',
			opacity: '0',
			transition: 'all .15s ease-out'
		}
	},
	checkbox2Container: {
		marginTop: '-15px',
		marginBottom: '15px',
		'& input[value=true] ~ label:after': {
			opacity: '.99'
		}
	},
	checkboxWrapper: {
		display: 'block',
		margin: '0 0 5px 0',
		background: Colors.ligthGrey2,
		border: `1px solid ${Colors.greyAlto}`,
		padding: '14px 12px'
	},
	adresseBlock: {
		border: `1px solid ${Colors.greyAlto}`,
		padding: '20px 25px',
		marginBottom: '10px',
		'& div': {
			alignItems: 'start !important'
		}
	},
	h5: {
		fontSize: '20px',
		fontWeight: '600',
		margin: '15px 0 10px 0'
	},
	h6: {
		color: Colors.secondary,
		margin: '20px 0 15px',
		fontSize: '18px',
		fontWeight: 500,
		lineHeight: 1.2
	},
	greyBackgroundBlock: {
		background: Colors.darkWhite,
		padding: '15px 30px'
	},
	detailscontainer: {
		display: 'grid',
		alignItems: 'start',
		gridTemplateColumns: '50%43%',
		columnGap: '7%',
		[Breakpoints.maxWidth('lg')]: {
			gridTemplateColumns: '45%46%',
			columnGap: '12%'
		},
		[Breakpoints.maxWidth('md')]: {
			gridTemplateColumns: '100%',
			'& img': {
				marginTop: '15px !important',
				width: '80% !important'
			}
		},
		[Breakpoints.maxWidth('sm')]: {
			'& img': {
				width: '100% !important'
			}
		},
		lineHeight: '1.62em',
		// fontSize: '16px',
		color: Colors.lightBlack,
		'& img': {
			width: '100%',
			verticalAlign: 'middle',
			margin: 'auto'
		},
		'& ul': {
			paddingLeft: '18px',
			margin: 0,
			'& li::marker': {
				color: Colors.secondary
			}
		}
	},
	subContent: {
		display: 'grid',
		columnGap: '15px',
		rowGap: '10px',
		gridTemplateColumns: '10rem auto',
		alignItems: 'end',
		[Breakpoints.maxWidth('md')]: {
			gridTemplateColumns: '2fr auto'
		},
		[Breakpoints.maxWidth('sm')]: {
			gridTemplateColumns: '2fr auto'
		},
		[Breakpoints.minWidth('md')]: {
			'& span': {
				'white-space': 'nowrap'
			}
		}
	},
	reducedMarginBottom: {
		marginBottom: '18px'
	},
	image: {
		[Breakpoints.maxWidth('md')]: {
			width: '35%'
		}
	},
	errorCheck: {
		color: `${Colors.red} !important`,
		':before': {
			border: `1px solid ${Colors.red}`
		}
	}
})

// const { pageAssets } = requestForm()

export const isBalconyOrPorchPermitGR6_1 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_1BalconyOrPorch

export const isResidentialLandPermitGR6_2 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_2ResidentialLand

export const isResidentialLandPermitGR6_3 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_3ParkingLot
export const isResidentialLandPermitGR6_4 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_4BoatDock

export const isResidentialLandPermitGR6_5 = (value) =>
	value?.toString() ==
	REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_5Divers

export const radioListWhatToDo = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_whatToDo_firstOption,
		value: REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_1BalconyOrPorch,
		key: 'request_form_landDevelopmentWorkPermit_whatToDo_firstOption'
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_whatToDo_secondOption,
		value: REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_2ResidentialLand,
		key: 'request_form_landDevelopmentWorkPermit_whatToDo_secondOption'
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_whatToDo_thirdOption,
		value: REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_3ParkingLot,
		key: 'request_form_landDevelopmentWorkPermit_whatToDo_thirdOption'
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_whatToDo_fourthOption,
		value: REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_4BoatDock,
		key: 'request_form_landDevelopmentWorkPermit_whatToDo_fourthOption'
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_whatToDo_fifthOption,
		value: REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_5Divers,
		key: 'request_form_landDevelopmentWorkPermit_whatToDo_fifthOption'
	}
]

export const radioListRequestAs = (pageAssets): RadioList[] => {
	return [
		{
			label: pageAssets?.request_form_individual,
			value: REQUEST_CONFIGS_KEYS.requestAs.individual,
			key: 'request_form_individual'
		},
		{
			label: pageAssets?.request_form_entreprise,
			value: REQUEST_CONFIGS_KEYS.requestAs.entreprise,
			key: 'request_form_entreprise'
		},
		{
			label: pageAssets?.request_form_entrepreneur_or_manager,
			value: REQUEST_CONFIGS_KEYS.requestAs.entrepreneur_or_manager,
			key: 'request_form_entrepreneur_or_manager'
		}
	]
}

export const radioListYesNo = (pageAssets): RadioList[] => [
	{
		label: pageAssets.request_form_select_yes,
		value: 'true',
		key: 'request_form_select_yes'
	},
	{
		label: pageAssets.request_form_select_no,
		value: 'false',
		key: 'request_form_select_no'
	}
]

// STEP 2
export const radioListAddressOption = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets.request_form_addressInfoSection_addressOption_secondOption_label,
		value: REQUEST_CONFIGS_KEYS.researchType.cadastralNumber,
		key: 'request_form_addressInfoSection_addressOption_secondOption_label'
	},
	{
		label:
			pageAssets.request_form_addressInfoSection_addressOption_firstOption_label,
		value: REQUEST_CONFIGS_KEYS.researchType.address,
		key: 'request_form_addressInfoSection_addressOption_firstOption_label'
	}
]

// STEP 3
export const radioListMainUseOfExistingBuildingLandDevWorkPermit = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.firstOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1_extraText
	},
	{
		label:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.secondOption,
		key: 'request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2',
		extraText:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2_extraText
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_installationType_option7,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.thirdOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_installationType_option7',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_installationType_option7_extraText
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_installationType_option4,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.fourthOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_installationType_option4',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_installationType_option4_extraText
	}
]

export const radioListMainUseOfExistingBuildingForParkingLandDevWorkPermit = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.firstOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfNewBuilding_option1_extraText
	},
	{
		label:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2,
		value:
			REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.secondOption,
		key: 'request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2',
		extraText:
			pageAssets?.request_form_residentialRenovationOrRepairPermit_mainUseOfExistingBuilding_option2_extraText
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option4,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.thirdOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option4',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option4_extraText
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option2,
		value:
			REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.fourthOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option2',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_mainUseOfExistingBuilding_option2
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot,
		value: REQUEST_CONFIGS_KEYS.mainUseOfExistingBuildingForParking.fifthOption,
		key: 'request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot_extraText
	}
]

export const radioListMixteOrOther = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOther_option1,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.firstOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOther_option1'
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOther_option3,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.secondOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOther_option3'
	}
]

export const radioListOnlyResidentialOrOther = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOther_option1,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.firstOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOther_option1'
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOther_option3,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.secondOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOther_option3'
	}
]

export const radioListUseOfBuildingOrLand = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_residential,
		value: REQUEST_CONFIGS_KEYS.useOfBuildingOrLand.residential,
		key: 'request_form_landDevWorkPermit_useOfBuildingOrLand_residential',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_residential_extraText
	},
	{
		label: pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_mixed,
		value:
			REQUEST_CONFIGS_KEYS.useOfBuildingOrLand
				.agriculturalIndustrialInstitutionalCommercialOrMixed,
		key: 'request_form_landDevWorkPermit_useOfBuildingOrLand_mixed',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_mixed_extraText
	}
]

export const radioListUseOfBuildingBoat = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_residential,
		value: REQUEST_CONFIGS_KEYS.useOfBuildingBoat.residential,
		key: 'request_form_landDevWorkPermit_useOfBuildingBoat_residential',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_residential_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_industrialCommercialOrMixed,
		value: REQUEST_CONFIGS_KEYS.useOfBuildingBoat.industrialCommercialOrMixed,
		key: 'request_form_landDevWorkPermit_useOfBuildingBoat_industrialCommercialOrMixed',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_industrialCommercialOrMixed_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_agricultural,
		value: REQUEST_CONFIGS_KEYS.useOfBuildingBoat.agriculturalBuilding,
		key: 'request_form_landDevWorkPermit_useOfBuildingBoat_agricultural',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_agricultural_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot,
		value: REQUEST_CONFIGS_KEYS.useOfBuildingBoat.emptyLot,
		key: 'request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingBoat_emptyLot_extraText
	}
]

export const radioListUseOfBuildingDiverse = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_residential,
		value: REQUEST_CONFIGS_KEYS.useOfBuildingOrLand.residential,
		key: 'request_form_landDevWorkPermit_useOfBuildingOrLand_residential',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_residential_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_diverse,
		value:
			REQUEST_CONFIGS_KEYS.useOfBuildingOrLand
				.agriculturalIndustrialInstitutionalCommercialOrMixed,
		key: 'request_form_landDevWorkPermit_useOfBuildingOrLand_diverse',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_diverse_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_agricultural,
		value: REQUEST_CONFIGS_KEYS.useOfBuildingOrLand.agriculturalBuildingOrLand,
		key: 'request_form_landDevWorkPermit_useOfBuildingOrLand_agricultural',
		extraText:
			pageAssets?.request_form_landDevWorkPermit_useOfBuildingOrLand_agricultural_extraText
	}
]

export const radioListResidentialOrOther = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOther_option1,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.firstOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOther_option1'
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOther_option2,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.secondOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOther_option2'
	}
]

export const radioListResidentialOrOtherDiverse = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOtherDiverse_option1,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.firstOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOtherDiverse_option1'
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isResidentialOrOtherDiverse_option2,
		value: REQUEST_CONFIGS_KEYS.isResidentialOrOther.secondOption,
		key: 'request_form_landDevWorkPermit_isResidentialOrOtherDiverse_option2'
	}
]

export const radioListStructureType = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_structureType_option1,
		value: REQUEST_CONFIGS_KEYS.structureType.firstOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_structureType_option1',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_structureType_option1_extraText
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_structureType_option2,
		value: REQUEST_CONFIGS_KEYS.structureType.secondOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_structureType_option2',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_structureType_option2_extraText
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_structureType_option3,
		value: REQUEST_CONFIGS_KEYS.structureType.thirdOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_structureType_option3',
		extraText:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_structureType_option3_extraText
	}
]

// **********************************************************************
// **********************************************************************
// **********************************************************************
// **********************************************************************

export const radioListTypesOfWorkBalcony = (pageAssets): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkBalcony_firstOption,
		key: 'request_form_landDevWorkPermit_typesOfWorkBalcony_firstOption',
		value: REQUEST_CONFIGS_KEYS.typesOfWork.firstOption,
		checked: false,
		extraText:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkBalcony_firstOption_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkBalcony_secondOption,
		key: 'request_form_landDevWorkPermit_typesOfWorkBalcony_secondOption',
		value: REQUEST_CONFIGS_KEYS.typesOfWork.secondOption,
		checked: false,
		extraText:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkBalcony_secondOption_extraText
	}
]

// !Important
export const isBalconySectionA = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfWork.firstOption)
}

export const isBalconySectionB = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfWork.secondOption)
}

export const installationTypeBalconyList = (
	pageAssets,
	diplayOptionDetails
): RadioList[] => [
	{
		label: pageAssets?.select_landDevWorkPermit_installTypeBalcony_firstOption,
		value: REQUEST_CONFIGS_KEYS.installationTypeBalcony.firstOption,
		key: 'select_landDevWorkPermit_installTypeBalcony_firstOption',
		extraText:
			pageAssets?.select_landDevWorkPermit_installTypeBalcony_firstOption_extraText,
		details: diplayOptionDetails(amenagementBalcon)
	},
	{
		label: pageAssets?.select_landDevWorkPermit_installTypeBalcony_secondOption,
		value: REQUEST_CONFIGS_KEYS.installationTypeBalcony.secondOption,
		key: 'select_landDevWorkPermit_installTypeBalcony_secondOption',
		extraText:
			pageAssets?.select_landDevWorkPermit_installTypeBalcony_secondOption_extraText,
		details: diplayOptionDetails(amenagementGalerie)
	},
	{
		label: pageAssets?.select_landDevWorkPermit_installTypeBalcony_thirdOption,
		value: REQUEST_CONFIGS_KEYS.installationTypeBalcony.thirdOption,
		key: 'select_landDevWorkPermit_installTypeBalcony_thirdOption',
		extraText:
			pageAssets?.select_landDevWorkPermit_installTypeBalcony_thirdOption_extraText,
		details: diplayOptionDetails(amenagementperron)
	},
	{
		label: pageAssets?.select_landDevWorkPermit_installTypeBalcony_fourthOption,
		value: REQUEST_CONFIGS_KEYS.installationTypeBalcony.fourthOption,
		key: 'select_landDevWorkPermit_installTypeBalcony_fourthOption',
		extraText:
			pageAssets?.select_landDevWorkPermit_installTypeBalcony_fourthOption_extraText,
		details: diplayOptionDetails(amenagementporche)
	}
]

export const radioListFoundationTypeBalcony = (pageAssets): SelectList[] => [
	{
		label: '',
		value: '',
		key: ''
	},
	{
		label: pageAssets?.request_form_landDevWorkPermit_fondationType_option1,
		value: REQUEST_CONFIGS_KEYS.fondationTypeBalcony.firstOption,
		key: 'request_form_landDevWorkPermit_fondationType_option1'
	},
	{
		label: pageAssets?.request_form_landDevWorkPermit_fondationType_option2,
		value: REQUEST_CONFIGS_KEYS.fondationTypeBalcony.secondOption,
		key: 'request_form_landDevWorkPermit_fondationType_option2'
	},
	{
		label: pageAssets?.request_form_landDevWorkPermit_fondationType_option3,
		value: REQUEST_CONFIGS_KEYS.fondationTypeBalcony.thirdOption,
		key: 'request_form_landDevWorkPermit_fondationType_option3'
	},
	{
		label: pageAssets?.request_form_select_label_other,
		value: REQUEST_CONFIGS_KEYS.fondationTypeBalcony.fourthOption,
		key: 'request_form_select_label_other'
	}
]

export const radioListIsTerraceInclude = (pageAssets): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isTerraceInclude_firstOption,
		key: 'request_form_landDevWorkPermit_isTerraceInclude_firstOption',
		value: REQUEST_CONFIGS_KEYS.isTerraceInclude.firstOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isTerraceInclude_secondOption,
		key: 'request_form_landDevWorkPermit_isTerraceInclude_secondOption',
		value: REQUEST_CONFIGS_KEYS.isTerraceInclude.secondOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isTerraceInclude_thirdOption,
		key: 'request_form_landDevWorkPermit_isTerraceInclude_thirdOption',
		value: REQUEST_CONFIGS_KEYS.isTerraceInclude.thirdOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isTerraceInclude_fourthOption,
		key: 'request_form_landDevWorkPermit_isTerraceInclude_fourthOption',
		value: REQUEST_CONFIGS_KEYS.isTerraceInclude.fourthOption,
		checked: false
	}
]

export const isTypeOfWorkSectionA = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.isOutdoorStorage.acousticScreen)
}

export const isTypeOfWorkSectionB = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.isOutdoorStorage.outdoorStorage)
}

export const isTypeOfWorkSectionC = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.isOutdoorStorage.fuelTank)
}

export const isGR6_3TypesOfWorkToPerformParkingSectionA = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.firstOption
	)
}

export const isGR6_3TypesOfWorkToPerformParkingSectionB = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.secondOption
	)
}

export const isGR6_3TypesOfWorkToPerformParkingSectionC = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.thirdOption
	)
}

export const isGR6_3ParkingSectionW = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.areOtherModificationsInvolvedParking.firstOption
	)
}

export const isGR6_3ParkingSectionX = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.areOtherModificationsInvolvedParking.secondOption
	)
}

export const isGR6_3ParkingSectionY = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.areOtherModificationsInvolvedParking.thirdOption
	)
}

export const radioListTypesOfWorkBoat = (pageAssets): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_isBoatDevelopment_pierOrShelter,
		key: 'request_form_landDevelopmentWorkPermit_isBoatDevelopment_pierOrShelter',
		value: REQUEST_CONFIGS_KEYS.isBoatDevelopment.pierOrShelter,
		extraText:
			pageAssets?.request_form_landDevelopmentWorkPermit_isBoatDevelopment_pierOrShelter_extraText,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_isBoatDevelopment_landingStage,
		key: 'request_form_landDevelopmentWorkPermit_isBoatDevelopment_landingStage',
		value: REQUEST_CONFIGS_KEYS.isBoatDevelopment.landingStage,
		extraText:
			pageAssets?.request_form_landDevelopmentWorkPermit_isBoatDevelopment_landingStage_extraText,
		checked: false
	}
]

export const radioListTypesOfPier = (pageAssets): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_boatType_floatingPier,
		key: 'request_form_landDevelopmentWorkPermit_boatType_floatingPier',
		value: REQUEST_CONFIGS_KEYS.typesOfStructureBoat.floatingPier,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_boatType_pilesPier,
		key: 'request_form_landDevelopmentWorkPermit_boatType_pilesPier',
		value: REQUEST_CONFIGS_KEYS.typesOfStructureBoat.pilesPier,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_boatType_stakePier,
		key: 'request_form_landDevelopmentWorkPermit_boatType_stakePier',
		value: REQUEST_CONFIGS_KEYS.typesOfStructureBoat.stakePier,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_boatType_wheelPier,
		key: 'request_form_landDevelopmentWorkPermit_boatType_wheelPier',
		value: REQUEST_CONFIGS_KEYS.typesOfStructureBoat.wheelPier,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_boatType_boatShelter,
		key: 'request_form_landDevelopmentWorkPermit_boatType_boatShelter',
		value: REQUEST_CONFIGS_KEYS.typesOfStructureBoat.boatShelter,
		checked: false
	},
	{
		label: pageAssets?.request_form_select_label_other,
		key: 'request_form_select_label_other',
		value: REQUEST_CONFIGS_KEYS.typesOfStructureBoat.other,
		checked: false
	}
]

export const radioListTypesOfWorkDiverse = (pageAssets): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_isOutdoorStorage_acousticScreen,
		key: 'request_form_landDevelopmentWorkPermit_isOutdoorStorage_acousticScreen',
		value: REQUEST_CONFIGS_KEYS.isOutdoorStorage.acousticScreen,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_isOutdoorStorage_fuelTank,
		key: 'request_form_landDevelopmentWorkPermit_isOutdoorStorage_fuelTank',
		value: REQUEST_CONFIGS_KEYS.isOutdoorStorage.fuelTank,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevelopmentWorkPermit_isOutdoorStorage_outdoorStorage,
		key: 'request_form_landDevelopmentWorkPermit_isOutdoorStorage_outdoorStorage',
		value: REQUEST_CONFIGS_KEYS.isOutdoorStorage.outdoorStorage,
		checked: false
	}
]

// Dimensions *****

// Measurement unit m or ft
export const radioListMeasurementUnit = (pageAssets): RadioList[] => [
	{
		label: pageAssets?.request_form_meters,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.meters_unit,
		key: 'request_form_meters'
	},
	{
		label: pageAssets?.request_form_foot,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.foot_unit,
		key: 'request_form_foot'
	}
]

// Measurement unit m² or ft²
export const radioListMeasurement2Unit = (pageAssets): RadioList[] => [
	{
		label: pageAssets?.request_form_meters2,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.meters_unit,
		key: 'request_form_meters2'
	},
	{
		label: pageAssets?.request_form_foot2,
		value: REQUEST_CONFIGS_KEYS.measurement_unit.foot_unit,
		key: 'request_form_foot2'
	}
]

export const radioListWhoWillBeInChargeOfWork = (pageAssets): RadioList[] => [
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_firstOption,
		value: REQUEST_CONFIGS_KEYS.whoWillBeInChargeOfWork.firstOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_firstOption'
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_secondOption,
		value: REQUEST_CONFIGS_KEYS.whoWillBeInChargeOfWork.secondOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_secondOption'
	},
	{
		label:
			pageAssets?.request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_thirdOption,
		value: REQUEST_CONFIGS_KEYS.whoWillBeInChargeOfWork.thirdOption,
		key: 'request_form_buildingConstructionOrAdditionPermit_whoWillBeInChargeOfWork_thirdOption'
	}
]

// **********************************************************************
// **********************************************************************
// **********************************************************************
// **********************************************************************

//*********************************************
// GR6.2
export const checkboxListTypesOfWorkResidentialLand = (
	pageAssets
): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_preparationTerrain,
		key: 'request_form_landDevWorkPermit_typesOfWorkResidentialLand_preparationTerrain',
		value: REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand.preparationTerrain,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_remblaiDeblaiDecontamination,
		key: 'request_form_landDevWorkPermit_typesOfWorkResidentialLand_remblaiDeblaiDecontamination',
		value:
			REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand
				.remblaiDeblaiDecontamination,
		checked: false,
		extraText:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_remblaiDeblaiDecontamination_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_ajoutDeplacementMuret,
		key: 'request_form_landDevWorkPermit_typesOfWorkResidentialLand_ajoutDeplacementMuret',
		value:
			REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand.ajoutDeplacementMuret,
		checked: false,
		extraText:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_ajoutDeplacementMuret_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_ajoutDeplacementMurSoutenement,
		key: 'request_form_landDevWorkPermit_typesOfWorkResidentialLand_ajoutDeplacementMurSoutenement',
		value:
			REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand
				.ajoutDeplacementMurSoutenement,
		checked: false,
		extraText:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_ajoutDeplacementMurSoutenement_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_bandeTampon,
		key: 'request_form_landDevWorkPermit_typesOfWorkResidentialLand_bandeTampon',
		value: REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand.bandeTampon,
		checked: false,
		extraText:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_bandeTampon_extraText
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_amenagementPaysagerGazonnement,
		key: 'request_form_landDevWorkPermit_typesOfWorkResidentialLand_amenagementPaysagerGazonnement',
		value:
			REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand
				.amenagementPaysagerGazonnement,
		checked: false,
		extraText:
			pageAssets?.request_form_landDevWorkPermit_typesOfWorkResidentialLand_amenagementPaysagerGazonnement_extraText
	}
]

// !Important
export const isGR6_2SectionA = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand.preparationTerrain
	)
}

export const isGR6_2SectionB = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand.remblaiDeblaiDecontamination
	)
}

export const isGR6_2SectionC = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand.ajoutDeplacementMuret
	)
}

export const isGR6_2SectionD = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand
			.ajoutDeplacementMurSoutenement
	)
}

export const isGR6_2SectionE = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand.bandeTampon
	)
}

export const isGR6_2SectionF = (value) => {
	return value?.includes(
		REQUEST_CONFIGS_KEYS.typesOfWorkResidentialLand
			.amenagementPaysagerGazonnement
	)
}

export const isGR6_4SectionA = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfStructureBoat.other)
}
export const isGR6_4SectionB = (value) => {
	return value
		?.split(', ')
		.some((r) =>
			[
				REQUEST_CONFIGS_KEYS.typesOfStructureBoat.floatingPier,
				REQUEST_CONFIGS_KEYS.typesOfStructureBoat.pilesPier,
				REQUEST_CONFIGS_KEYS.typesOfStructureBoat.stakePier,
				REQUEST_CONFIGS_KEYS.typesOfStructureBoat.wheelPier
			].includes(r)
		)
}

export const isGR6_4SectionC = (value) => {
	return value?.includes(REQUEST_CONFIGS_KEYS.typesOfStructureBoat.boatShelter)
}

export const radioListLandDevAddOrMoving = (pageAssets): RadioList[] => [
	{
		label: pageAssets?.request_form_landDevWorkPermit_ajout,
		value: REQUEST_CONFIGS_KEYS.landDevAddOrMoving.ajout,
		key: 'request_form_landDevWorkPermit_ajout'
	},
	{
		label: pageAssets?.request_form_landDevWorkPermit_deplacement,
		value: REQUEST_CONFIGS_KEYS.landDevAddOrMoving.deplacement,
		key: 'request_form_landDevWorkPermit_deplacement'
	}
]

export const radioListTypesOfWorkToPerformParking = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_firstOption,
		value: REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.firstOption,
		key: 'request_form_LandDevelopmentWork_typesOfWorkToPerformParking_firstOption',
		extraText:
			pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_firstOption_extraText
	},
	{
		label:
			pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_secondOption,
		value: REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.secondOption,
		key: 'request_form_LandDevelopmentWork_typesOfWorkToPerformParking_secondOption',
		extraText:
			pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_secondOption_extraText
	},
	{
		label:
			pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_thirdOption,
		value: REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.thirdOption,
		key: 'request_form_LandDevelopmentWork_typesOfWorkToPerformParking_thirdOption',
		extraText:
			pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_thirdOption_extraText
	}
]

export const checkboxListModificationsDrivewayEntranceParking = (
	pageAssets
): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_firstOption,
		key: 'request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_firstOption',
		value:
			REQUEST_CONFIGS_KEYS.modificationsDrivewayEntranceParking.firstOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_secondOption,
		key: 'request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_secondOption',
		value:
			REQUEST_CONFIGS_KEYS.modificationsDrivewayEntranceParking.secondOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_thirdOption,
		key: 'request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_thirdOption',
		value:
			REQUEST_CONFIGS_KEYS.modificationsDrivewayEntranceParking.thirdOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_fourthOption,
		key: 'request_form_landDevWorkPermit_modificationsDrivewayEntranceParking_fourthOption',
		value:
			REQUEST_CONFIGS_KEYS.modificationsDrivewayEntranceParking.fourthOption,
		checked: false
	}
]

export const checkboxListAreOtherModificationsInvolvedParking = (
	pageAssets
): CheckboxList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_firstOption,
		key: 'request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_firstOption',
		value:
			REQUEST_CONFIGS_KEYS.areOtherModificationsInvolvedParking.firstOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_secondOption,
		key: 'request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_secondOption',
		value:
			REQUEST_CONFIGS_KEYS.areOtherModificationsInvolvedParking.secondOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_thirdOption,
		key: 'request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_thirdOption',
		value:
			REQUEST_CONFIGS_KEYS.areOtherModificationsInvolvedParking.thirdOption,
		checked: false
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_fourthOption,
		key: 'request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_fourthOption',
		value:
			REQUEST_CONFIGS_KEYS.areOtherModificationsInvolvedParking.fourthOption,
		checked: false
	}
]

export const radioListDesiredModificationParking = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_desiredModificationParking_firstOption,
		value: REQUEST_CONFIGS_KEYS.desiredModificationParking.firstOption,
		key: 'request_form_landDevWorkPermit_desiredModificationParking_firstOption'
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_desiredModificationParking_secondOption,
		value: REQUEST_CONFIGS_KEYS.desiredModificationParking.secondOption,
		key: 'request_form_landDevWorkPermit_desiredModificationParking_secondOption'
	}
]

export const radioListisAddingOrMovingWallParking = (
	pageAssets
): RadioList[] => [
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isAddingOrMovingWallParking_firstOption,
		value: REQUEST_CONFIGS_KEYS.desiredModificationParking.firstOption,
		key: 'request_form_landDevWorkPermit_isAddingOrMovingWallParking_firstOption'
	},
	{
		label:
			pageAssets?.request_form_landDevWorkPermit_isAddingOrMovingWallParking_secondOption,
		value: REQUEST_CONFIGS_KEYS.desiredModificationParking.secondOption,
		key: 'request_form_landDevWorkPermit_isAddingOrMovingWallParking_secondOption'
	}
]
